import store from '@shared/store/index';

export function callForecasterBriefcaseFilter(){
  const isActiveBriefcase = store.getters['Forecasters/isUserBriefcaseFilterActived'];
  if(isActiveBriefcase){
    store.dispatch('Forecasters/toggleUserAssetsFilter', true);
  }
}